"use strict";

export default {
  setSubscriptionDetail(state, payload) {
    state.subscriptionDetail = payload;
  },
};
